// Dated GST-status lookup for the RCTI. See netlify/functions/gst-status-sb.js for why
// dated GST exists and how it is written. Mirrors src/utils/rateActivations.js — same
// shape, same baseline sentinel, same period-start rule.
//
// GST is pinned to a PERIOD START, never a mid-period date — the engine bills a whole
// 28-day period on one basis, so a mid-period effective date could not be honoured and is
// deliberately not modelled. (An ABR registration date mid-period therefore takes effect
// from the following period start; that is a decision for the operator, not this file.)

export const BASELINE_FROM = '1900-01-01';

// The GST status in force for a period, or null when the driver has no dated history (→
// the caller falls back to the live drivers.gst_registered flag, i.e. behaviour is
// unchanged for every driver who has never been checked). ISO dates compare as strings.
export function gstStatusFor(list, periodStartISO) {
  if (!Array.isArray(list) || !list.length || !periodStartISO) return null;
  let best = null;
  for (const a of list) {
    if (!a || !a.effectiveFromISO || a.effectiveFromISO > periodStartISO) continue;
    if (!best || a.effectiveFromISO > best.effectiveFromISO) best = a;
  }
  return best;
}

// True once a driver is on dated GST — used to show that the RCTI is no longer reading
// the live flag for them.
export function isGstDated(list) {
  return Array.isArray(list) && list.some((a) => a && !a.baseline);
}

// The real (non-baseline) changes, newest first, for display.
export function gstHistory(list) {
  return (Array.isArray(list) ? list : [])
    .filter((a) => a && !a.baseline)
    .sort((a, b) => (b.effectiveFromISO || '').localeCompare(a.effectiveFromISO || ''));
}
